import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class PermissionsexporterService {

  constructor() { }

  exportPermissionsToExcel(roles: any[]) {
    
  const workbook: XLSX.WorkBook = XLSX.utils.book_new();

  roles.forEach(role => {
    if (!role?.permissions?.length) {
      return;
    }

    const rows: any[] = [];

    role.permissions.forEach(category => {
      const activePermissions = category.permissions.filter(p => p.isActive);
      if (!activePermissions.length) return;
      activePermissions
      .forEach((permission, index) => {
        rows.push({
          Kategori: index === 0 ? category.category : '',
          Behörighet: permission.description
        });
      });
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);

    // Autosize kolumner (enkel variant)
    worksheet['!cols'] = [
      { wch: 25 }, // Category
      { wch: 45 }
    ];

     Object.keys(worksheet).forEach(key => {
      if (key.startsWith('A')) { // kolumn A = Category
        const cell = worksheet[key];
        if (cell.v) { // bara celler med text
          cell.s = {
            font: { bold: true }
          };
        }
      }
    });
    
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      role.label.substring(0, 31) // Excel max 31 tecken
    );
  });

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob = new Blob(
    [excelBuffer],
    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
  );

  saveAs(blob, 'permissions-per-role.xlsx');
}
}
